export const borderColors = [
  "rgb(255, 99, 132)",
  "rgb(255, 159, 64)",
  "rgb(255, 205, 86)",
  "rgb(75, 192, 192)",
  "rgb(54, 162, 235)",
  "rgb(153, 102, 255)",
  "rgb(201, 203, 207)",
  "rgb(0,123,255)",
  "rgb(102,16,242)",
  "rgb(111,66,193)",
  "rgb(232,62,140)",
  "rgb(220,53,69)",
  "rgb(253,126,20)",
  "rgb(255,193,7)",
  "rgb(40,167,69)",
  "rgb(32,201,151)",
  "rgb(23,162,184)",
];

export const backgroundColors = [
  "rgb(255, 99, 132, 0.4)",
  "rgb(255, 159, 64, 0.4)",
  "rgb(255, 205, 86, 0.4)",
  "rgb(75, 192, 192, 0.4)",
  "rgb(54, 162, 235, 0.4)",
  "rgb(153, 102, 255, 0.4)",
  "rgb(201, 203, 207, 0.4)",
  "rgb(0,123,255, 0.4)",
  "rgb(102,16,242, 0.4)",
  "rgb(111,66,193, 0.4)",
  "rgb(232,62,140, 0.4)",
  "rgb(220,53,69, 0.4)",
  "rgb(253,126,20, 0.4)",
  "rgb(255,193,7, 0.4)",
  "rgb(40,167,69, 0.4)",
  "rgb(32,201,151, 0.4)",
  "rgb(23,162,184, 0.4)",

];
